import { OrdersSummary } from './OrdersSummary'
import { OrdersTable } from './OrdersTable'
import { OrdersProvider } from './OrdersContext'

import { Container, Content } from './style'


export function Orders() {
    return(
        <Container>

            <div className="fill" />

            <Content>
                <OrdersProvider>
                    <OrdersSummary />
                    <OrdersTable />
                </OrdersProvider>
            </Content>

        </Container>
    )
}
